import moment, { Moment } from "moment";

export class QuartersEngine {
  public mondaysOfQuarters: Map<String, Date[]> = new Map();
  quarterStartDates: Date[] = [];

  public static findMonday(date: Date): Date {
    let currentDate = new Date(date);
    while (currentDate.getDay() != 1) {
      currentDate.setDate(currentDate.getDate() - 1);
    }
    currentDate.setHours(1, 0, 0, 0);
    return currentDate;
  }
  public static findMondayMoment(date: Moment): Moment {
    let currentDate = moment(date);
    while (currentDate.isoWeekday() != 1) {
      currentDate.set("date", currentDate.get("date") - 1);
    }
    return currentDate;
  }

  public static findSunday(date: Date): Date {
    let currDate = new Date(date);
    while (currDate.getDay() != 0) {
      currDate.setDate(currDate.getDate() + 1);
    }
    currDate.setHours(1, 0, 0, 0);
    return currDate;
  }
  public static findSundayMoment(date: Moment): Moment {
    let currentDate = moment(date);
    while (currentDate.isoWeekday() != 7) {
      currentDate.set("date", currentDate.get("date") + 1);
    }
    return currentDate;
  }

  public static mondaysOfProjectFinder(
    startDate: Date,
    endDate: Date,
    mondays: Date[] = [],
  ) {
    let currentDate = startDate;

    while (currentDate <= endDate) {
      if (currentDate.getDay() === 1) {
        mondays.push(new Date(currentDate));
        currentDate.setDate(startDate.getDate() + 7);
      } else {
        currentDate.setDate(startDate.getDate() - 1);
      }
    }
    return mondays;
  }
  public static mondaysOfProjectFinderMoment(
    startDate: Moment,
    endDate: Moment,
    mondays: Moment[] = [],
  ) {
    let currentDate = startDate;
    console.log(currentDate);

    while (currentDate.isBefore(endDate)) {
      if(currentDate.isoWeekday() == 1){
        mondays.push(moment(currentDate));
        currentDate.add(7,'day')
      } else {
        currentDate.add(-1, 'day');
      }
    }
    return mondays;
  }

  public selectMondaysOfQuarter(offset: number = 0, mondays: Date[]) {
    if (offset == 0) {
      return mondays.slice(0, 12);
    } else {
      return mondays.slice(12 * offset - 1, 12);
    }
  }

  public static findMonths(s: Date, e: Date): Date[] {
    let startDate = new Date(s);
    startDate.setDate(1);
    let months: Date[] = [];
    while (startDate.getTime() <= e.getTime()) {
      months.push(new Date(startDate));
      if (startDate.getMonth() == 11) {
        startDate.setMonth(0);
        startDate.setFullYear(startDate.getFullYear() + 1);
      } else {
        startDate.setMonth(startDate.getMonth() + 1);
      }
    }

    return months;
  }

  public static findMonthsMoment(s: Moment, e: Moment): Moment[] {
    let startDate = moment(s).utc(false);
    console.log(startDate);

    if([1,2,3,4,5,6,7].includes(e.get("date"))){
      e.add(7, "day")
    }
    startDate.set("date", 1);
    let months: Moment[] = [];
    while (startDate.isBefore(e)) {
      months.push(moment(startDate));
      if (startDate.get("M") == 11) {
        startDate.set("M", 0);
        startDate.set("year", startDate.get("year") + 1);
      } else {
        startDate.set("month", startDate.get("month") + 1);
      }
    }
    
    return months;
  }
}
